<script lang="ts" setup>
import SearchResults from '@/views/search/SearchResults.vue';
import NewProjects from '@/views/search/NewProjects.vue';
</script>

<template>
  <NewProjects placement="search" />
  <SearchResults />
</template>

<style lang="css" scoped></style>
